/**
 * SCD Lot 5 — Scénario de session (mode formateur).
 * Défini par la licence maître, reçu via /licenses/validate, appliqué à la
 * création d'entreprise. Le tick (appelé par Layout à chaque changement de
 * jour) déclenche les événements forcés et clôt le scénario à J+durée.
 */
import { EVENTS } from '../../data/events';
import { generateId } from '../helpers';
import { computeScoreComposite } from '../../utils/scenario';
import { genererDebrief } from '../../utils/debrief';
import { bilanAmeliorations } from '../../utils/ameliorations';

export const createSessionScenarioSlice = (set, get) => ({
  // { id, nom, description, objectifs, dureeJours, startDay, evenementsForces,
  //   firedEvents, ended, ackEnd, resultat }
  sessionScenario: null,

  /** Applique le scénario du formateur juste après createCompany. */
  applySessionScenario: (scenario) => {
    if (!scenario) return;
    const s = get();
    const patch = {
      sessionScenario: {
        id: scenario.id || 'custom',
        nom: scenario.nom || 'Scénario personnalisé',
        description: scenario.description || '',
        objectifs: scenario.objectifs || [],
        dureeJours: scenario.duree_jours || 90,
        startDay: s.totalDays || 0,
        evenementsForces: scenario.evenements_forces || [],
        firedEvents: [],
        ended: false,
        ackEnd: false,
        resultat: null,
      },
    };
    // Départ décalé (ex. Premier Noël : novembre).
    if (scenario.start_month) patch.month = scenario.start_month;
    // Bonus de trésorerie (ex. Second magasin : +15 000 €).
    if (scenario.treasury_bonus) patch.treasury = (s.treasury || 0) + scenario.treasury_bonus;
    set(patch);
  },

  /** Tick appelé quand totalDays change : événements forcés + fin de scénario. */
  sessionScenarioTick: () => {
    const s = get();
    const sc = s.sessionScenario;
    if (!sc || sc.ended || !s.gameStarted) return;
    const elapsed = (s.totalDays || 0) - (sc.startDay || 0);

    // Événements forcés par le scénario (ex. discount concurrent à J+15).
    (sc.evenementsForces || []).forEach((f) => {
      if (elapsed >= f.jour && !(get().sessionScenario.firedEvents || []).includes(f.eventId)) {
        const ev = EVENTS.find(e => e.id === f.eventId);
        const cur = get().sessionScenario;
        if (ev) {
          set({
            pendingEvents: [...(get().pendingEvents || []), { ...ev, instanceId: generateId(), resolvedAt: null }],
            sessionScenario: { ...cur, firedEvents: [...(cur.firedEvents || []), f.eventId] },
          });
        } else {
          set({ sessionScenario: { ...cur, firedEvents: [...(cur.firedEvents || []), f.eventId] } });
        }
      }
    });

    // Fin de scénario : fige le résultat (KPI + score composite).
    if (elapsed >= sc.dureeJours) {
      const r = get().retail;
      const treasury = Math.round(get().treasury || 0);
      const caCumul = r?.stats?.caCumul || 0;
      const satisfaction = r?.marketing?.satisfaction ?? 0;
      const resultat = {
        treasury,
        caCumul,
        satisfaction,
        noteAvis: r?.marketing?.noteAvis ?? null,
        nbMagasins: r ? 1 + (r.magasins || []).length : 1,
        caWebCumul: r?.ecommerce?.stats?.caWebCumul || 0,
        equipements: r ? bilanAmeliorations(r) : null,
        score: computeScoreComposite({ treasury, caCumul, satisfaction }),
        // Débrief pédagogique automatique (règles métier).
        debrief: genererDebrief(get()),
      };
      set({ sessionScenario: { ...get().sessionScenario, ended: true, resultat } });
    }
  },

  /** Ferme l'écran de résultats (la partie continue librement). */
  ackScenarioEnd: () => {
    const sc = get().sessionScenario;
    if (sc) set({ sessionScenario: { ...sc, ackEnd: true } });
  },
});
